export const CustomerCDStorageChargeType = {
    none: 0,
    hours: 1,
    date: 2,
};


export const CustomerCDServiceChargeType = {
    kilo: 1,
    ppl: 2,
};


export const CustomerCCTOCDChangeType = {
    none: 0,
    minutes: 1,
};
